// extracted by mini-css-extract-plugin
export var card = "_pq-0";
export var content = "_pq-2";
export var details = "_pq-3";
export var icon = "_pq-1";
export var iconBlue = "_pq-5";
export var iconBrand = "_pq-4";
export var iconGrayBlue = "_pq-6";
export var iconGreen = "_pq-7";
export var iconIndigo = "_pq-8";
export var iconOrange = "_pq-9";
export var iconPurple = "_pq-a";
export var iconRed = "_pq-b";
export var iconWarning = "_pq-c";